import { post } from '..';

const GetLocationMetadata = (externalIds: string[]) => post('locations/metadata', { externalIds });

export default GetLocationMetadata;
